function getArticleSlugByName(title: string): string {
  return title
    ?.toLowerCase()
    .replace(/([^\w]|[\s])+/g, '-')
    .replace(/-+$/g, '');
}

export default getArticleSlugByName;
